<template>
    <div>

        <p>
            Mode

            <b-select v-model="mode" :options="[
                { text: 'csv vers xlsx', value: 'csv vers xlsx' },
                { text: 'xlsx vers csv', value: 'xlsx vers csv' }
            ]"></b-select> 
        </p>
        <p>
            Extension

            <b-select v-model="extension" :options="[
                { text: 'xlsx', value: 'xlsx' },
                { text: 'xlsm', value: 'xslm' }
            ]"></b-select> 
        </p>
        <p>
            Nom de l'onglet

            <b-input v-model="name_sheet" />
        </p>
        <p>
            Image

            <b-checkbox v-model="image" />
        </p>
        <p>
            Colonnes à garder au format texte
            <div v-for="(column, idx) in column_exclude_numeric_conversion" :key="idx" style="display: flex; align-items: center; margin-bottom: 5px;">
                <b-input 
                    :list="'columns' + id" 
                    v-model="column_exclude_numeric_conversion[idx]"
                    style="flex: 1; margin-right: 5px;"
                />
                <b-button variant="danger" size="sm" @click="removeColumn(idx)">
                    <i class="fas fa-trash"></i>
                </b-button>
            </div>
            <b-button variant="success" size="sm" @click="addColumn">
                <i class="fas fa-plus"></i> Ajouter une colonne
            </b-button>
            
            <datalist :id="'columns' + id">
                <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
            </datalist>
        </p>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    var clone = require("clone");
    
    export default {
        name: "xlsx",
		components: {
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			step_position: {
				default: 0
			}
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),
                mode: "csv vers xlsx",
                extension: "xlsx",
                name_sheet: "Sheet",
                image: false,
                column_exclude_numeric_conversion: []
			};
        },
        methods: {
            addColumn()
            {
                this.column_exclude_numeric_conversion.push("");
            },
            removeColumn(idx)
            {
                this.column_exclude_numeric_conversion.splice(idx, 1);
            },
            get_data()
            {
                return this.save()
            },
            save()
            {
                console.log("save");

                var data = {
                    mode: this.mode,
                    extension: this.extension,
                    name_sheet: this.name_sheet,
                    image: this.image,
                    column_exclude_numeric_conversion: this.column_exclude_numeric_conversion
                }

                return data;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                this.mode = data.mode;
                this.extension = data.extension;
                this.name_sheet = data.name_sheet;
                this.image = data.image;
                this.column_exclude_numeric_conversion = data.column_exclude_numeric_conversion || [];
            },
        },
        async mounted()
        {
        }
    }
</script>

<style scoped>
</style>